import ls from 'local-storage'
import axios from 'axios';
import { get, post } from '../util/AcessoApi';
import moment from "moment"


const URL_BACKEND = (process.env.REACT_APP_ENV.toString() === 'production' ? process.env.REACT_APP_URL_PRODUCTION : process.env.REACT_APP_URL_DEVELOPMENT)

const getAutenticado = _ => {
    const user = ls.get('usuario')
    return user !== null
}

function setSistemaStatus(setFunction) {
    if (!isFunction(setFunction))
        return;
    try {
        Promise.resolve(obterStatusSistema()).then(function (ret) {
            if (ret == "on")
                setFunction(false)
            else
                setFunction(true)

        }).catch(e => {
            //
            setFunction(true)
        })
    } catch (error) {
        setFunction(true)
        throw error
    }
}

const setSistemaVersao = async (setFunction) => {
    if (!isFunction(setFunction))
        return;
    try {
        Promise.resolve(obterVersaoBackend()).then(function (ret) {
            setFunction(ret)

        }).catch(e => {
            //
            setFunction('off')
        })
    } catch (error) {
        setFunction('off')
        throw error
    }
}
function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
const obterStatusSistema = async () => {
    let ret = "off";
    const errorFunction = function (err) {
        ret = "off"
    }
    await get('/sistema/status', null, null, errorFunction).then(function (res) {
        ret = res !== "on" ? "off" : res;
    })

    return ret;
}
const obterVersaoBackend = async () => {
    let ret2 = "off";
    const errorFunction = function (err) {
        ret2 = "off"
    }
    await get('/sistema/versaobackend', null, null, errorFunction).then(function (res) {
        ret2 = res;
    })

    return ret2;
}
const getUsuario = _ => ls.get('usuario')

const getConfig = () => {
    const user = getUsuario()

    return {
        headers: {
            'Authorization': (user && user.token) || '',
            'Access-Control-Allow-Origin': '*'
        }
    }
}

const getApi = (setData, url, callback, modulo, noAuth) => {
    const user = getUsuario()

    const config = {
        headers: { 'Authorization': (user && user.token) || '' },
        params: {
            modulo_id: modulo
        }
    }

    if (noAuth)
        axios.get(URL_BACKEND + url)
            .then(res => {
                setData(res.data)
                callback && callback()
            })
            .catch(res => console.log('ERRO,', res))
    else
        axios.get(URL_BACKEND + url, config)
            .then(res => {
                setData(res.data)
                callback && callback()
            })
            .catch(res => console.log('ERRO ', res))

}

const getApiSetLocalStorage = (chaveLocalStorage, url, callback) => {
    return axios.get(URL_BACKEND + url, getConfig())
        .then(res => {
            ls.set(chaveLocalStorage, res.data)
            callback && callback()
            return res.data
        })
}

const logout = async (auditar) => {
    await new Promise(async (resolve, reject) => {
        if (auditar !== false) {
            let user = getUsuario()
            await Promise.resolve(post('/controleAcesso/usuario/logout', user, false, null, true)).then(function (val) {
            })
        }
        await ls.remove('usuario')
        await ls.remove('permissaoDashboard')
        await ls.remove('ultimo_hora_login')
        resolve();
    })
}

const reload = () => {
    window.location.reload();
}

const MENU = [
    {
        id: 'dashboard',
        nome: 'Dashboard',
        icone: 'icon-Dashboard',
        caminho: '/dashboard',
        modulo: 4
    },
    // {
    //     id: 'faturamento',
    //     nome: 'Faturamento',
    //     icone: 'icon-Coins',
    //     submenu: [
    //         {
    //             nome: 'Paciente',
    //             icone: 'icon-Mens',
    //             caminho: '/faturamento/beneficiario/consulta',
    //             modulo: 6
    //         },
    //         {
    //             nome: 'Cooperado PF',
    //             icone: 'icon-Doctor',
    //             caminho: '/faturamento/cooperadopf/consulta',
    //             modulo: 6
    //         },
    //         {
    //             nome: 'Cooperado PJ',
    //             icone: 'icon-Business-ManWoman',
    //             caminho: '/faturamento/cooperadopj/consulta',
    //             modulo: 6
    //         }
    //     ]
    // },
    {
        id: 'atendimento',
        nome: 'Atendimento',
        icone: 'icon-Hospital',
        submenu: [
            {
                nome: 'Agenda',
                icone: 'icon-Calendar-3',
                caminho: '/atendimento/agenda/consulta',
                modulo: 10
            },
            {
                nome: 'Paciente',
                icone: 'icon-Mens',
                caminho: '/atendimento/beneficiario/consulta',
                modulo: 6
            },
            {
                nome: 'Prontuário',
                icone: 'icon-File-ClipboardFileText',
                caminho: '/atendimento/prontuario/consulta',
                modulo: 9
            },
            {
                nome: 'Prestador',
                icone: 'icon-Business-ManWoman',
                caminho: '/atendimento/prestador/consulta',
                modulo: 11
            },
            {
                nome: 'Prestador Conselho Profissional',
                icone: 'icon-Geo3',
                caminho: '/atendimento/prestadorconselhoprof/consulta',
                modulo: 13
            },
            {
                nome: 'Prestador CBOS',
                icone: 'icon-Medical-Sign',
                caminho: '/atendimento/prestadorcbos/consulta',
                modulo: 12
            },

            {
                nome: 'Sala de Espera',
                icone: 'icon-Clinic',
                caminho: '/atendimento/sala-espera/consulta',
                modulo: 10
            }
        ]
    },
    {
        id: 'controle-acesso',
        nome: 'Controle de Acesso',
        icone: 'icon-Add-User',
        submenu: [
            {
                nome: 'Usuario',
                icone: 'icon-Add-User',
                caminho: '/controleAcesso/usuario/consulta',
                modulo: 1
            },
            {
                nome: 'Grupo',
                icone: ' icon-Business-ManWoman',
                caminho: '/controleAcesso/grupo/consulta',
                modulo: 2
            },
            {
                nome: 'Auditoria',
                icone: ' icon-File-Search',
                caminho: '/controleAcesso/auditoria/consulta',
                modulo: 5
            },
        ]
    }
]

const obterMenuComPermissoes = async () => {
    try {
        let retorno = null
        await get('/controleAcesso/permissao/obterTodas', { usuario_id: getUsuario().id }).then(function (array) {
            let copia = MENU

            let s = copia.map(x => {
                x.permitido = x.submenu === undefined || x.submenu.filter(y => y.permitido === true).length > 0
                if (x.submenu != undefined) {
                    x.submenu.map((z, idx) => {
                        if (z.submenu) {
                            const lvSubmenu = z.submenu.filter(lv3 => {
                                const arrayFiltrado = array.filter(ar => ar.modulo_id.toString() === lv3.modulo.toString())[0];
                                return arrayFiltrado.permissoes != null && arrayFiltrado.permissoes[0] != null
                            })

                            if (!(lvSubmenu.length > 0)) {
                                z.permitido = false
                            } else {
                                z.submenu = lvSubmenu
                            }

                            return;
                        } else {
                            let submenuPermitido = true
                            if (z.modulo != undefined) {
                                let permissoes = array.filter(ar => ar.modulo_id.toString() == z.modulo.toString())[0].permissoes.filter(z => z != null)
                                submenuPermitido = permissoes != undefined ? permissoes.length > 0 : true
                                z.array = permissoes
                            }
                            z.permitido = submenuPermitido
                            return z
                        }
                    })
                }
                return x
            })

            try {
                if (s && s[0] && s[0].modulo == 66 && array.filter(ar => ar.modulo_id === 66).find(ar => ar).permissoes.filter(x => x !== null).length < 1) {
                    s.splice(0, 1);
                }
            } catch (error) {

            }


            retorno = s
        })



        return retorno == null ? MENU : retorno;
    } catch (error) {
        return MENU
    }

}

function minutosEmInatividade() {
    if (!ls.get('usuario'))
        return 9000;
    let segundosUltimoLogin = 0;
    try {
        segundosUltimoLogin = moment().diff(ls.get('ultimo_hora_login'), 'minutes');
    }
    catch (e) {
        console.log(e, 'erro ao calcular tempo ultimo login login');
    }
    return segundosUltimoLogin;
}

function verificarPermissao(modulo, acao, funcao) {
    let user = ls.get('usuario');
    const objPermissao = {
        usuario_id: (user && user.id) || 0,
        modulo_id: modulo,
        acao_id: acao
    }

    get('/controleAcesso/permissao', objPermissao).then(val => {
        if (val.length)
            funcao(true);
        else
            funcao(false);

    }).catch(e => {
        funcao(false);
    })
}

export { URL_BACKEND, getAutenticado, logout, reload, minutosEmInatividade, MENU, getApi, getUsuario, getConfig, getApiSetLocalStorage, obterMenuComPermissoes, setSistemaStatus, setSistemaVersao, verificarPermissao }